import PropTypes from "prop-types"

import PeriodSelectionHOC from "../period_selection_hoc"
import ConnectedServicesChart from "./connected_services_chart"
import ServiceStats from "./service_stats"
import topServicesFetcher from "./top_services_fetcher"
import StatCard from "../stat_card"
import { calculateChangeRate } from "../lib"

const TopServices = ({
  data: {
    worksWithData,
    firstTimeUsers,
    firstTimeUsersLastPeriod,
    totalServices,
    totalServicesLastPeriod,
  },
  serviceName,
  timePeriodInDays,
  onDetailSelect,
  servicesUrl,
  showPage,
}) => (
  <>
    <div className="top-services-header">
      <div className="services-chart">
        <ConnectedServicesChart
          data={worksWithData}
          firstTimeUsers={firstTimeUsers}
          totalUsers={worksWithData.reduce(
            (acc, val) => acc + val.activeUsers,
            0
          )}
          serviceName={serviceName}
          count={timePeriodInDays}
          servicesUrl={servicesUrl}
          onDetailSelect={onDetailSelect}
        />
      </div>
      <div className="services-stats">
        <div className="stat-group">
          <StatCard
            stat={firstTimeUsers}
            changeRate={calculateChangeRate(
              firstTimeUsers,
              firstTimeUsersLastPeriod
            )}
            statText={"Services connected for the first time"}
            className="adjacent"
            timePeriodInDays={timePeriodInDays}
            compactThreshold={99999}
          />
        </div>
        <div className="stat-group">
          <StatCard
            stat={totalServices}
            changeRate={calculateChangeRate(
              totalServices,
              totalServicesLastPeriod
            )}
            statText={"Unique services connected to your service"}
            className="adjacent"
            timePeriodInDays={timePeriodInDays}
            compactThreshold={99999}
          />
        </div>
      </div>
    </div>
    <div className="connected-services-list">
      {worksWithData.map((svcData, i) => (
        <ServiceStats
          data={svcData}
          serviceName={serviceName}
          key={i}
          timePeriodInDays={timePeriodInDays}
          url={
            servicesUrl != null && svcData.channel
              ? `${servicesUrl}/${svcData.channel.module_name}`
              : "#"
          }
          onDetailSelect={servicesUrl == null ? onDetailSelect : null}
        />
      ))}
    </div>
    {showPage && (
      <div className="action-buttons-container">
        <a
          role="button"
          className="button-secondary button-outlined"
          href={servicesUrl}
        >
          View all connected services
        </a>
      </div>
    )}
  </>
)

TopServices.propTypes = {
  data: PropTypes.shape({
    worksWithData: PropTypes.array,
    firstTimeUsers: PropTypes.number,
    firstTimeUsersLastPeriod: PropTypes.number,
    totalServices: PropTypes.number,
    totalServicesLastPeriod: PropTypes.number,
  }),
  serviceName: PropTypes.string.isRequired,
  timePeriodInDays: PropTypes.number.isRequired,
  onDetailSelect: PropTypes.func,
  servicesUrl: PropTypes.string,
  showPage: PropTypes.bool,
}

export default PeriodSelectionHOC({
  WrappedComponent: TopServices,
  serviceMetricsFetcher: topServicesFetcher,
  headerText: "Services connected",
  subHeaderText: "The top services connected to %SERVICE_NAME%",
  fetchDailyComparisonData: true,
  limit: 6,
})
